// src/analytics.ts
var ANALYTICS_BATCH_MAX_EVENTS = 50;
var ANALYTICS_PROPERTIES_MAX_CHARS = 4096;
var ANALYTICS_CLOCK_SKEW_MS = 24 * 60 * 60 * 1e3;

// src/auth.ts
var AUTH_PATH_PREFIX = "/v1/auth";
var ACTIVE_COMPANY_COOKIE_NAME = "tandemone.active_company";
var SUPER_SCOPE = "super";
var additionalUserFields = {
  isSuper: {
    type: "boolean",
    required: true,
    defaultValue: false,
    input: false
  }
};

// src/countries.ts
var UNITED_STATES_COUNTRY_CODE = "US";
var COUNTRY_NAME_BY_CODE = {
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "\xC5land Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barth\xE9lemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Caribbean Netherlands",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Democratic Republic of the Congo",
  CF: "Central African Republic",
  CG: "Republic of the Congo",
  CH: "Switzerland",
  CI: "C\xF4te d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Cura\xE7ao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn Islands",
  PR: "Puerto Rico",
  PS: "Palestinian Territories",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "R\xE9union",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "S\xE3o Tom\xE9 and Pr\xEDncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Eswatini",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "U.S. Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Vatican City",
  VC: "Saint Vincent and Grenadines",
  VE: "Venezuela",
  VG: "British Virgin Islands",
  VI: "U.S. Virgin Islands",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe"
};
var COUNTRY_ALIASES = {
  burma: "MM",
  czechia: "CZ",
  "congo brazzaville": "CG",
  "congo kinshasa": "CD",
  "dr congo": "CD",
  "great britain": "GB",
  "hong kong sar china": "HK",
  "ivory coast": "CI",
  "macao sar china": "MO",
  macau: "MO",
  "myanmar burma": "MM",
  "russian federation": "RU",
  turkiye: "TR",
  uk: "GB",
  usa: "US",
  "united states of america": "US",
  "viet nam": "VN"
};
function normalizeKey(value) {
  return value.normalize("NFD").replace(/\p{Diacritic}/gu, "").toLowerCase().replace(/&/g, " and ").replace(/[^a-z0-9]+/g, " ").trim();
}
var CODE_BY_LOOKUP = /* @__PURE__ */ new Map();
for (const [code, name] of Object.entries(COUNTRY_NAME_BY_CODE)) {
  CODE_BY_LOOKUP.set(normalizeKey(name), code);
  if (name.startsWith("Saint ")) {
    CODE_BY_LOOKUP.set(normalizeKey(`St ${name.slice(6)}`), code);
  }
}
for (const [alias, code] of Object.entries(COUNTRY_ALIASES)) {
  CODE_BY_LOOKUP.set(normalizeKey(alias), code);
}
function resolveCountryCode(input) {
  const trimmed = input?.trim();
  if (!trimmed) return null;
  const upper = trimmed.toUpperCase();
  if (upper.length === 2 && upper in COUNTRY_NAME_BY_CODE) {
    return upper;
  }
  return CODE_BY_LOOKUP.get(normalizeKey(trimmed)) ?? null;
}
function countryNameFromCode(code) {
  const resolved = resolveCountryCode(code);
  return resolved ? COUNTRY_NAME_BY_CODE[resolved] : null;
}

// src/plan.ts
var NO_PLAN_FEATURES = {
  isListedInDirectory: false,
  canSendRfi: false,
  canReceiveRfi: false,
  canViewRfiDetail: false,
  canViewDocumentInsights: false
};
var PLAN_FEATURE_KEYS = Object.keys(
  NO_PLAN_FEATURES
);
var PLAN_CATALOG = {
  buyer_free: {
    id: "buyer_free",
    label: "Buyers",
    seatLimit: null,
    monthlyPriceCents: 0,
    yearlyPriceCents: 0,
    features: {
      ...NO_PLAN_FEATURES,
      canSendRfi: true
    },
    coversRepSuppliers: false
  },
  supplier_free: {
    id: "supplier_free",
    label: "Supplier Free",
    /* deliberately looser than pro's cap of 3: seats are not the paid
     * differentiator, features are. so a growth company with 8 seats is blocked
     * from pro but can drop to free and keep all 8. accepted, not overlooked. */
    seatLimit: null,
    monthlyPriceCents: 0,
    yearlyPriceCents: 0,
    /* sending is not a paid differentiator: a supplier sourcing from other
     * suppliers is ordinary behaviour, and gating it only suppressed demand the
     * marketplace wants. responding to a received rfi stays paid. */
    features: {
      ...NO_PLAN_FEATURES,
      isListedInDirectory: true,
      canSendRfi: true,
      canReceiveRfi: true
    },
    coversRepSuppliers: false
  },
  supplier_pro: {
    id: "supplier_pro",
    label: "Supplier Pro",
    seatLimit: 3,
    monthlyPriceCents: 14900,
    yearlyPriceCents: 149e3,
    features: {
      ...NO_PLAN_FEATURES,
      isListedInDirectory: true,
      canSendRfi: true,
      canReceiveRfi: true,
      canViewRfiDetail: true
    },
    coversRepSuppliers: false
  },
  supplier_growth: {
    id: "supplier_growth",
    label: "Supplier Growth",
    seatLimit: null,
    monthlyPriceCents: 39900,
    yearlyPriceCents: 399e3,
    features: {
      ...NO_PLAN_FEATURES,
      isListedInDirectory: true,
      canSendRfi: true,
      canReceiveRfi: true,
      canViewRfiDetail: true,
      canViewDocumentInsights: true
    },
    coversRepSuppliers: true
  }
};
function isPaidPlan(planId) {
  return PLAN_CATALOG[planId].monthlyPriceCents > 0;
}
var PURCHASABLE_PLAN_IDS = [
  "supplier_pro",
  "supplier_growth"
];
var PLAN_IDS = Object.keys(PLAN_CATALOG);
function isPlanOffered(planId, company) {
  if (!company.isManufacturingRep || !isPaidPlan(planId)) return true;
  return PLAN_CATALOG[planId].coversRepSuppliers;
}
function freePlanFor(roles) {
  return roles.isSupplier ? "supplier_free" : "buyer_free";
}
function unionFeatures(a, b) {
  const merged = { ...NO_PLAN_FEATURES };
  for (const key of PLAN_FEATURE_KEYS) merged[key] = a[key] || b[key];
  return merged;
}

// src/billing.ts
var INVOICE_BILLED_COUNTRIES = ["IN", "CN", "PK"];
function resolveCollectionMethod(input) {
  if (input.forceInvoice !== null) {
    return input.forceInvoice ? "send_invoice" : "charge_automatically";
  }
  const code = resolveCountryCode(input.country);
  const invoiced = INVOICE_BILLED_COUNTRIES;
  return code && invoiced.includes(code) ? "send_invoice" : "charge_automatically";
}
var BILLING_ACTIVATION_FAILURES = [
  "no_payment_method",
  "card_declined",
  "stripe_error"
];
var ACTIVATION_RETRY_LABELS = {
  no_payment_method: "Add a card",
  card_declined: "Try another card",
  stripe_error: "Try again"
};
function isCompedSubscription(row) {
  return Boolean(
    row && row.source === "manual" && row.planId && isPaidPlan(row.planId)
  );
}
function effectiveSeatCap(entitlements) {
  const current = {
    limit: entitlements.seatLimit,
    planId: entitlements.planId,
    planLabel: entitlements.planLabel,
    isPending: false
  };
  const candidates = [
    entitlements.scheduledPlanId,
    entitlements.pendingPlanId
  ].filter((id) => id !== null);
  return candidates.reduce((tightest, id) => {
    const limit = PLAN_CATALOG[id].seatLimit;
    if (limit === null) return tightest;
    if (tightest.limit !== null && tightest.limit <= limit) return tightest;
    return {
      limit,
      planId: id,
      planLabel: PLAN_CATALOG[id].label,
      isPending: true
    };
  }, current);
}
var NO_ENTITLEMENTS = {
  ...NO_PLAN_FEATURES,
  planId: "buyer_free",
  planLabel: PLAN_CATALOG.buyer_free.label,
  seatLimit: null,
  status: "none",
  billingInterval: null,
  currentPeriodEnd: null,
  cancelAtPeriodEnd: false,
  scheduledPlanId: null,
  scheduledBillingInterval: null,
  pendingPlanId: null,
  hasOpenInvoice: false,
  activationFailure: null,
  activationFailedAt: null,
  activationFailedPlanId: null,
  hasEverSubscribed: false,
  isStaffOverride: false,
  billedThrough: null
};

// src/capabilities.ts
var CAPABILITY_TAXONOMY_VERSION = 2;
var CAPABILITY_TAXONOMY = [
  {
    key: "metal_removal_forming",
    label: "Metal Removal & Forming",
    groups: [
      {
        key: "machining_milling",
        label: "Machining \u2014 Milling",
        items: [
          { key: "machining_milling_3_axis_cnc", label: "3-axis CNC" },
          { key: "machining_milling_4_5_axis", label: "4-axis / 5-axis" },
          {
            key: "machining_milling_mill_turn",
            label: "Mill-turn / multi-task"
          },
          {
            key: "machining_milling_hmc_pallet",
            label: "HMC / pallet systems"
          },
          { key: "machining_milling_jig_boring", label: "Jig boring" }
        ]
      },
      {
        key: "machining_turning",
        label: "Machining \u2014 Turning",
        items: [
          { key: "machining_turning_cnc_lathe", label: "CNC lathe / turning" },
          {
            key: "machining_turning_turn_mill",
            label: "Turn-mill (live tooling)"
          },
          {
            key: "machining_turning_swiss",
            label: "Swiss / sliding headstock"
          },
          {
            key: "machining_turning_multi_spindle",
            label: "Multi-spindle screw machine"
          },
          { key: "machining_turning_vtl", label: "Vertical turning (VTL)" }
        ]
      },
      {
        key: "machining_grinding",
        label: "Machining \u2014 Grinding",
        items: [
          {
            key: "machining_grinding_cylindrical",
            label: "Cylindrical (OD / ID)"
          },
          { key: "machining_grinding_surface", label: "Surface grinding" },
          {
            key: "machining_grinding_centerless",
            label: "Centerless grinding"
          },
          {
            key: "machining_grinding_honing",
            label: "Honing / superfinishing"
          },
          { key: "machining_grinding_lapping", label: "Lapping" }
        ]
      },
      {
        key: "edm_specialty_machining",
        label: "EDM & Specialty Machining",
        items: [
          { key: "edm_specialty_wire_edm", label: "Wire EDM" },
          { key: "edm_specialty_sinker_edm", label: "Sinker EDM" },
          {
            key: "edm_specialty_deep_hole_drilling",
            label: "Deep hole / gun drilling"
          },
          { key: "edm_specialty_broaching", label: "Broaching" },
          {
            key: "edm_specialty_gear_hobbing",
            label: "Gear hobbing / grinding"
          }
        ]
      },
      {
        key: "stamping",
        label: "Stamping",
        items: [
          { key: "stamping_progressive_die", label: "Progressive die" },
          { key: "stamping_transfer_die", label: "Transfer die" },
          { key: "stamping_deep_draw", label: "Deep draw / draw forming" },
          { key: "stamping_fine_blanking", label: "Fine blanking" },
          { key: "stamping_fourslide", label: "Fourslide / multislide" },
          { key: "stamping_coining_embossing", label: "Coining / embossing" },
          {
            key: "stamping_washers_clips",
            label: "Washers, clips & retaining rings"
          }
        ]
      },
      {
        key: "sheet_metal_fabrication",
        label: "Sheet Metal Fabrication",
        items: [
          {
            key: "sheet_metal_laser_cutting",
            label: "Laser cutting (fiber / CO\u2082)"
          },
          { key: "sheet_metal_waterjet_cutting", label: "Waterjet cutting" },
          { key: "sheet_metal_plasma_cutting", label: "Plasma cutting" },
          { key: "sheet_metal_press_brake", label: "CNC press brake" },
          { key: "sheet_metal_turret_punch", label: "Turret punch" },
          { key: "sheet_metal_tube_structural", label: "Tube / structural fab" }
        ]
      },
      {
        key: "roll_forming_extrusion",
        label: "Roll Forming & Extrusion",
        items: [
          {
            key: "roll_forming_extrusion_roll_forming",
            label: "Roll forming (profiles)"
          },
          {
            key: "roll_forming_extrusion_aluminum",
            label: "Aluminum extrusion"
          },
          {
            key: "roll_forming_extrusion_cold_impact",
            label: "Cold / impact extrusion"
          },
          { key: "roll_forming_extrusion_hydroforming", label: "Hydroforming" },
          {
            key: "roll_forming_extrusion_metal_spinning",
            label: "Metal spinning"
          }
        ]
      },
      {
        key: "forging",
        label: "Forging",
        items: [
          { key: "forging_closed_die", label: "Closed-die forging" },
          { key: "forging_open_die", label: "Open-die / hand forging" },
          { key: "forging_cold_heading", label: "Cold heading / cold forging" },
          { key: "forging_rotary_orbital", label: "Rotary / orbital forging" }
        ]
      },
      {
        key: "fastener_manufacturing",
        label: "Fastener Manufacturing",
        items: [
          {
            key: "fastener_manufacturing_cold_heading",
            label: "Cold heading (multi-station / bolt maker)"
          },
          {
            key: "fastener_manufacturing_nut_forming",
            label: "Nut forming & tapping"
          },
          {
            key: "fastener_manufacturing_thread_rolling",
            label: "Thread rolling & cutting"
          },
          {
            key: "fastener_manufacturing_pins_studs",
            label: "Pins, studs, rivets & clinch parts"
          }
        ]
      },
      {
        key: "metal_materials_mill_products",
        label: "Metal Materials & Mill Products",
        items: [
          {
            key: "metal_materials_mill_products_continuous_cast_copper",
            label: "Continuous-cast copper rod"
          },
          {
            key: "metal_materials_mill_products_aluminum_rod_billet",
            label: "Aluminum rod & billet"
          },
          {
            key: "metal_materials_mill_products_copper_alloy_strip",
            label: "Copper / alloy strip & sheet"
          },
          {
            key: "metal_materials_mill_products_wire_drawing",
            label: "Wire drawing & wire processing"
          },
          {
            key: "metal_materials_mill_products_tube_extruded",
            label: "Tube & extruded profiles"
          },
          {
            key: "metal_materials_mill_products_precious_metal",
            label: "Precious metal refining & fabrication"
          }
        ]
      }
    ]
  },
  {
    key: "casting_molding",
    label: "Casting & Molding",
    groups: [
      {
        key: "die_casting",
        label: "Die Casting",
        items: [
          { key: "die_casting_aluminum_hpdc", label: "Aluminum HPDC" },
          { key: "die_casting_zinc_hpdc", label: "Zinc / Zamak HPDC" },
          { key: "die_casting_magnesium_hpdc", label: "Magnesium HPDC" },
          {
            key: "die_casting_vacuum_assist",
            label: "Vacuum-assist die casting"
          },
          { key: "die_casting_semi_solid", label: "Semi-solid / thixocasting" }
        ]
      },
      {
        key: "castings_sand_investment",
        label: "Castings \u2014 Sand & Investment",
        items: [
          {
            key: "castings_sand_investment_green_sand",
            label: "Green sand casting"
          },
          {
            key: "castings_sand_investment_no_bake",
            label: "No-bake / air-set sand"
          },
          {
            key: "castings_sand_investment_investment",
            label: "Investment casting (lost wax)"
          },
          {
            key: "castings_sand_investment_shell_mold",
            label: "Shell mold casting"
          },
          {
            key: "castings_sand_investment_lost_foam",
            label: "Lost foam casting"
          }
        ]
      },
      {
        key: "permanent_mold_casting",
        label: "Permanent Mold Casting",
        items: [
          {
            key: "permanent_mold_casting_gravity",
            label: "Gravity / permanent mold"
          },
          {
            key: "permanent_mold_casting_lpdc",
            label: "Low-pressure die casting (LPDC)"
          },
          {
            key: "permanent_mold_casting_tilt_pour",
            label: "Tilt-pour casting"
          }
        ]
      },
      {
        key: "plastic_injection_molding",
        label: "Plastic Injection Molding",
        items: [
          {
            key: "plastic_injection_molding_thermoplastic",
            label: "Thermoplastic IM"
          },
          { key: "plastic_injection_molding_insert", label: "Insert molding" },
          {
            key: "plastic_injection_molding_overmolding",
            label: "Overmolding / 2-shot"
          },
          {
            key: "plastic_injection_molding_gas_assist",
            label: "Gas-assist molding"
          },
          {
            key: "plastic_injection_molding_micro",
            label: "Micro injection molding"
          },
          {
            key: "plastic_injection_molding_structural_foam",
            label: "Structural foam molding"
          }
        ]
      },
      {
        key: "rubber_silicone_molding",
        label: "Rubber & Silicone Molding",
        items: [
          {
            key: "rubber_silicone_molding_lsr",
            label: "Liquid silicone rubber (LSR)"
          },
          {
            key: "rubber_silicone_molding_compression",
            label: "Compression molding"
          },
          {
            key: "rubber_silicone_molding_transfer",
            label: "Transfer molding"
          },
          {
            key: "rubber_silicone_molding_thermoset",
            label: "Thermoset / BMC molding"
          },
          { key: "rubber_silicone_molding_urethane", label: "Urethane casting" }
        ]
      },
      {
        key: "powder_metal_mim",
        label: "Powder Metal & MIM",
        items: [
          {
            key: "powder_metal_mim_pm_sintered",
            label: "Powder metal (P/M sintered)"
          },
          {
            key: "powder_metal_mim_mim",
            label: "Metal injection molding (MIM)"
          }
        ]
      },
      {
        key: "polymer_materials_compounding",
        label: "Polymer Materials & Compounding",
        items: [
          {
            key: "polymer_materials_compounding_resin_supply",
            label: "Resin & polymer supply"
          },
          {
            key: "polymer_materials_compounding_custom_toll",
            label: "Custom & toll compounding"
          },
          {
            key: "polymer_materials_compounding_color_masterbatch",
            label: "Color & additive masterbatch"
          },
          {
            key: "polymer_materials_compounding_medical_grade",
            label: "Medical-grade compounds"
          },
          {
            key: "polymer_materials_compounding_flexible_pvc",
            label: "Flexible PVC compounds"
          }
        ]
      }
    ]
  },
  {
    key: "joining_assembly_electronics",
    label: "Joining, Assembly & Electronics",
    groups: [
      {
        key: "welding",
        label: "Welding",
        items: [
          { key: "welding_mig_tig_stick", label: "MIG / TIG / Stick" },
          {
            key: "welding_spot_resistance",
            label: "Spot / resistance welding"
          },
          { key: "welding_laser", label: "Laser welding" },
          { key: "welding_friction_stir", label: "Friction stir (FSW)" },
          { key: "welding_orbital", label: "Orbital welding" },
          { key: "welding_robotic", label: "Robotic welding cell" }
        ]
      },
      {
        key: "brazing_soldering",
        label: "Brazing & Soldering",
        items: [
          { key: "brazing_soldering_furnace", label: "Furnace brazing" },
          { key: "brazing_soldering_torch", label: "Torch brazing" },
          { key: "brazing_soldering_induction", label: "Induction brazing" },
          {
            key: "brazing_soldering_soldering",
            label: "Soldering (electronics)"
          }
        ]
      },
      {
        key: "wire_harness_cable_assembly",
        label: "Wire Harness & Cable Assembly",
        items: [
          {
            key: "wire_harness_cable_assembly_custom_harness",
            label: "Custom wire harness"
          },
          {
            key: "wire_harness_cable_assembly_cable",
            label: "Cable assembly (terminated)"
          },
          {
            key: "wire_harness_cable_assembly_panel_wiring",
            label: "Panel wiring / UL 508A"
          },
          {
            key: "wire_harness_cable_assembly_electromechanical",
            label: "Electromechanical assembly"
          }
        ]
      },
      {
        key: "pcb_electronics_assembly",
        label: "PCB & Electronics Assembly",
        items: [
          { key: "pcb_electronics_assembly_smt", label: "SMT assembly" },
          {
            key: "pcb_electronics_assembly_through_hole",
            label: "Through-hole assembly"
          },
          {
            key: "pcb_electronics_assembly_box_build",
            label: "Box build / system integration"
          },
          {
            key: "pcb_electronics_assembly_potting",
            label: "Potting / encapsulation"
          },
          {
            key: "pcb_electronics_assembly_bare_board",
            label: "Bare board fabrication"
          },
          {
            key: "pcb_electronics_assembly_rigid_flex",
            label: "Rigid / flex / rigid-flex"
          },
          {
            key: "pcb_electronics_assembly_hdi_microvia",
            label: "HDI / microvia"
          },
          {
            key: "pcb_electronics_assembly_rf_microwave",
            label: "RF & microwave board fab"
          }
        ]
      },
      {
        key: "mechanical_assembly",
        label: "Mechanical Assembly",
        items: [
          {
            key: "mechanical_assembly_sub_assembly",
            label: "Sub-assembly / kitting"
          },
          {
            key: "mechanical_assembly_press_fit",
            label: "Press fit / bearing install"
          },
          {
            key: "mechanical_assembly_adhesive_bonding",
            label: "Adhesive bonding"
          },
          {
            key: "mechanical_assembly_plastic_welding",
            label: "Plastic welding (ultrasonic / vibe)"
          },
          {
            key: "mechanical_assembly_final_assembly",
            label: "Final product assembly"
          }
        ]
      }
    ]
  },
  {
    key: "additive_manufacturing",
    label: "Additive Manufacturing",
    groups: [
      {
        key: "additive_polymer",
        label: "Additive \u2014 Polymer",
        items: [
          { key: "additive_polymer_fdm", label: "FDM / FFF" },
          { key: "additive_polymer_sla", label: "SLA / DLP / MSLA (resin)" },
          {
            key: "additive_polymer_sls",
            label: "SLS (nylon / polymer powder)"
          },
          { key: "additive_polymer_mjf", label: "MJF (Multi Jet Fusion)" },
          {
            key: "additive_polymer_large_format",
            label: "Large-format FGF / pellet"
          }
        ]
      },
      {
        key: "additive_metal",
        label: "Additive \u2014 Metal",
        items: [
          {
            key: "additive_metal_dmls_slm",
            label: "DMLS / SLM (laser powder bed)"
          },
          { key: "additive_metal_ebm", label: "EBM (electron beam)" },
          { key: "additive_metal_ded", label: "DED / directed energy" },
          {
            key: "additive_metal_binder_jetting",
            label: "Binder jetting (metal)"
          }
        ]
      }
    ]
  },
  {
    key: "surface_treatment_finishing",
    label: "Surface Treatment & Finishing",
    groups: [
      {
        key: "plating_anodizing",
        label: "Plating & Anodizing",
        items: [
          {
            key: "plating_anodizing_zinc",
            label: "Zinc / zinc-nickel plating"
          },
          {
            key: "plating_anodizing_nickel",
            label: "Electroless & electrolytic nickel"
          },
          { key: "plating_anodizing_hard_chrome", label: "Hard chrome" },
          {
            key: "plating_anodizing_anodizing",
            label: "Anodizing (Type II / Type III)"
          },
          {
            key: "plating_anodizing_chromate",
            label: "Chromate conversion / Alodine"
          },
          {
            key: "plating_anodizing_black_oxide",
            label: "Black oxide / phosphate"
          },
          {
            key: "plating_anodizing_precious",
            label: "Gold / silver / tin plating"
          },
          { key: "plating_anodizing_pvd_dlc", label: "PVD / DLC coating" },
          { key: "plating_anodizing_zinc_flake", label: "Zinc flake coating" },
          {
            key: "plating_anodizing_mechanical_galv",
            label: "Mechanical galvanizing"
          },
          {
            key: "plating_anodizing_hot_dip_galv",
            label: "Hot dip galvanizing"
          },
          {
            key: "plating_anodizing_thread_locker",
            label: "Thread locker & sealant patch"
          }
        ]
      },
      {
        key: "painting_organic_coating",
        label: "Painting & Organic Coating",
        items: [
          { key: "painting_organic_coating_powder", label: "Powder coating" },
          {
            key: "painting_organic_coating_ecoat",
            label: "E-coat / electrocoat"
          },
          {
            key: "painting_organic_coating_liquid",
            label: "Liquid / spray paint"
          },
          {
            key: "painting_organic_coating_elastomeric",
            label: "Rubber / elastomeric coating"
          },
          {
            key: "painting_organic_coating_conformal",
            label: "Conformal coating (electronics)"
          }
        ]
      },
      {
        key: "mechanical_finishing",
        label: "Mechanical Finishing",
        items: [
          {
            key: "mechanical_finishing_deburring",
            label: "Deburring (manual / vibratory / TEM)"
          },
          {
            key: "mechanical_finishing_blasting",
            label: "Shot blast / bead blast"
          },
          {
            key: "mechanical_finishing_vibratory",
            label: "Vibratory / mass finishing"
          },
          {
            key: "mechanical_finishing_polishing",
            label: "Polishing / buffing"
          },
          {
            key: "mechanical_finishing_passivation",
            label: "Passivation (stainless)"
          },
          {
            key: "mechanical_finishing_electropolishing",
            label: "Electropolishing"
          },
          { key: "mechanical_finishing_shot_peening", label: "Shot peening" }
        ]
      },
      {
        key: "heat_treating",
        label: "Heat Treating",
        items: [
          {
            key: "heat_treating_hardening",
            label: "Hardening / quench & temper"
          },
          {
            key: "heat_treating_case_hardening",
            label: "Case hardening / carburizing"
          },
          {
            key: "heat_treating_nitriding",
            label: "Nitriding / nitrocarburizing"
          },
          { key: "heat_treating_induction", label: "Induction hardening" },
          {
            key: "heat_treating_annealing",
            label: "Annealing / stress relief"
          },
          {
            key: "heat_treating_solution_age",
            label: "Solution treat & age (Al)"
          },
          {
            key: "heat_treating_hydrogen_embrittlement",
            label: "Hydrogen embrittlement relief bake"
          },
          { key: "heat_treating_carbonitriding", label: "Carbonitriding" },
          { key: "heat_treating_austempering", label: "Austempering" },
          { key: "heat_treating_vacuum", label: "Vacuum heat treating" }
        ]
      },
      {
        key: "cleaning_pickling",
        label: "Cleaning & Pickling",
        items: [
          {
            key: "cleaning_pickling_aqueous",
            label: "Aqueous / ultrasonic parts washing"
          },
          { key: "cleaning_pickling_vapor", label: "Vapor degreasing" },
          { key: "cleaning_pickling_acid", label: "Acid pickling & descaling" }
        ]
      },
      {
        key: "sterilization_irradiation",
        label: "Sterilization & Irradiation",
        items: [
          {
            key: "sterilization_irradiation_ethylene_oxide",
            label: "Ethylene oxide (EtO)"
          },
          {
            key: "sterilization_irradiation_gamma",
            label: "Gamma irradiation"
          },
          { key: "sterilization_irradiation_ebeam", label: "E-beam" },
          { key: "sterilization_irradiation_xray", label: "X-ray" },
          {
            key: "sterilization_irradiation_vhp",
            label: "Vaporized hydrogen peroxide (VHP)"
          },
          {
            key: "sterilization_irradiation_cycle_dev",
            label: "Cycle development & validation"
          }
        ]
      }
    ]
  },
  {
    key: "sealing_gaskets_insulation",
    label: "Sealing, Gaskets & Insulation",
    groups: [
      {
        key: "gasket_fabrication",
        label: "Gasket Fabrication",
        items: [
          {
            key: "gasket_fabrication_die_cutting",
            label: "Die cutting / clicker press"
          },
          { key: "gasket_fabrication_waterjet", label: "Waterjet cutting" },
          {
            key: "gasket_fabrication_flash_cutting",
            label: "Flash cutting / oscillating knife (CNC)"
          },
          { key: "gasket_fabrication_laser", label: "Laser cutting" },
          {
            key: "gasket_fabrication_punch_press",
            label: "Punch press / kiss cutting"
          },
          {
            key: "gasket_fabrication_hand_cutting",
            label: "Hand cutting / custom shapes"
          }
        ]
      },
      {
        key: "spiral_wound_metallic_gaskets",
        label: "Spiral Wound & Metallic Gaskets",
        items: [
          {
            key: "spiral_wound_metallic_gaskets_spiral_wound",
            label: "Spiral wound gaskets (SW)"
          },
          {
            key: "spiral_wound_metallic_gaskets_ring_joint",
            label: "Ring joint gaskets (RJG)"
          },
          {
            key: "spiral_wound_metallic_gaskets_kammprofile",
            label: "Corrugated / kammprofile gaskets"
          },
          {
            key: "spiral_wound_metallic_gaskets_metal_jacketed",
            label: "Metal jacketed gaskets"
          },
          {
            key: "spiral_wound_metallic_gaskets_solid_metal",
            label: "Solid metal gaskets"
          }
        ]
      },
      {
        key: "molded_extruded_seals",
        label: "Molded & Extruded Seals",
        items: [
          {
            key: "molded_extruded_seals_o_rings",
            label: "O-rings (compression molded)"
          },
          {
            key: "molded_extruded_seals_custom_molded",
            label: "Custom molded seals"
          },
          {
            key: "molded_extruded_seals_lip_seals",
            label: "Lip seals / shaft seals"
          },
          {
            key: "molded_extruded_seals_extruded_profiles",
            label: "Extruded profiles & cord stock"
          },
          {
            key: "molded_extruded_seals_diaphragms",
            label: "Diaphragms & bellows"
          }
        ]
      },
      {
        key: "gasket_seal_materials",
        label: "Gasket & Seal Materials",
        items: [
          {
            key: "gasket_seal_materials_cnaf",
            label: "Compressed non-asbestos (CNAF)"
          },
          {
            key: "gasket_seal_materials_graphite",
            label: "Graphite / expanded graphite (Grafoil)"
          },
          { key: "gasket_seal_materials_ptfe", label: "PTFE / expanded PTFE" },
          {
            key: "gasket_seal_materials_cork_rubber",
            label: "Cork / rubber composites"
          },
          {
            key: "gasket_seal_materials_elastomer_sheet",
            label: "Silicone / EPDM / neoprene sheet"
          },
          {
            key: "gasket_seal_materials_fiber_sheet",
            label: "Fiber / cellulose sheet"
          },
          {
            key: "gasket_seal_materials_ceramic",
            label: "Ceramic / high-temp insulation"
          }
        ]
      },
      {
        key: "thermal_acoustic_insulation",
        label: "Thermal & Acoustic Insulation",
        items: [
          {
            key: "thermal_acoustic_insulation_fiberglass",
            label: "Fiberglass / mineral wool fabrication"
          },
          {
            key: "thermal_acoustic_insulation_ceramic_fiber",
            label: "Ceramic fiber blanket / board cutting"
          },
          {
            key: "thermal_acoustic_insulation_foam_tape",
            label: "Foam gaskets & tape conversion"
          },
          {
            key: "thermal_acoustic_insulation_acoustic_pads",
            label: "Acoustic damping pads"
          },
          {
            key: "thermal_acoustic_insulation_heat_shield",
            label: "Heat shield fabrication"
          }
        ]
      }
    ]
  },
  {
    key: "inspection_tooling_supply",
    label: "Inspection, Tooling & Supply",
    groups: [
      {
        key: "ndt_inspection",
        label: "NDT & Inspection",
        items: [
          { key: "ndt_inspection_cmm_scanning", label: "CMM / 3D scanning" },
          { key: "ndt_inspection_xray_ct", label: "X-ray / CT scanning" },
          {
            key: "ndt_inspection_ultrasonic",
            label: "Ultrasonic testing (UT)"
          },
          {
            key: "ndt_inspection_magnetic_particle",
            label: "Magnetic particle (MT)"
          },
          {
            key: "ndt_inspection_liquid_penetrant",
            label: "Liquid penetrant (PT)"
          },
          { key: "ndt_inspection_eddy_current", label: "Eddy current (ET)" },
          {
            key: "ndt_inspection_leak_pressure",
            label: "Leak / pressure testing"
          },
          {
            key: "ndt_inspection_optical_sorting",
            label: "100% optical sorting"
          },
          {
            key: "ndt_inspection_eddy_current_crack",
            label: "Eddy current crack detection"
          },
          {
            key: "ndt_inspection_hand_sort",
            label: "Hand sort, rework & containment"
          }
        ]
      },
      {
        key: "metrology_calibration",
        label: "Metrology & Calibration",
        items: [
          {
            key: "metrology_calibration_dimensional",
            label: "Dimensional metrology"
          },
          { key: "metrology_calibration_gage", label: "Gage calibration" },
          { key: "metrology_calibration_spc", label: "SPC / Cpk reporting" },
          {
            key: "metrology_calibration_fai",
            label: "First article inspection (FAI)"
          },
          { key: "metrology_calibration_ppap", label: "PPAP documentation" },
          {
            key: "metrology_calibration_mechanical_materials",
            label: "Mechanical & materials testing"
          }
        ]
      },
      {
        key: "tooling_die_build",
        label: "Tooling & Die Build",
        items: [
          {
            key: "tooling_die_build_progressive_die",
            label: "Progressive die build"
          },
          {
            key: "tooling_die_build_injection_mold",
            label: "Injection mold build"
          },
          {
            key: "tooling_die_build_fixtures_gaging",
            label: "Fixtures & gaging"
          },
          {
            key: "tooling_die_build_jigs_plates",
            label: "Jigs & tooling plates"
          },
          {
            key: "tooling_die_build_die_repair",
            label: "Die repair / maintenance"
          }
        ]
      },
      {
        key: "marking_traceability",
        label: "Marking & Traceability",
        items: [
          {
            key: "marking_traceability_laser",
            label: "Laser engraving / marking"
          },
          {
            key: "marking_traceability_dot_peen",
            label: "Dot peen / pin stamp"
          },
          {
            key: "marking_traceability_screen_pad",
            label: "Silk screening / pad printing"
          },
          {
            key: "marking_traceability_barcode",
            label: "Barcode / QR / 2D matrix"
          },
          { key: "marking_traceability_rfid", label: "RFID tagging" }
        ]
      },
      {
        key: "fastener_hardware_supply",
        label: "Fastener & Hardware Supply",
        items: [
          {
            key: "fastener_hardware_supply_standard",
            label: "Standard fastener distribution"
          },
          {
            key: "fastener_hardware_supply_custom",
            label: "Custom / specialty fasteners"
          },
          {
            key: "fastener_hardware_supply_import_export",
            label: "Import sourcing / export supply"
          },
          {
            key: "fastener_hardware_supply_wire_ribbon",
            label: "Wire & ribbon processing"
          }
        ]
      },
      {
        key: "raw_material_mill_product_supply",
        label: "Raw Material & Mill Product Supply",
        items: [
          { key: "raw_material_mill_product_supply_bar_rod", label: "Bar/Rod" },
          {
            key: "raw_material_mill_product_supply_plate_sheet",
            label: "Plate & Sheet"
          },
          {
            key: "raw_material_mill_product_supply_extrusions",
            label: "Extrusions"
          }
        ]
      }
    ]
  }
];
var leafIndex = {};
var itemToGroup = {};
var groupToCategory = {};
var categoryKeys = [];
var groupKeys = [];
var itemKeys = [];
for (const category of CAPABILITY_TAXONOMY) {
  categoryKeys.push(category.key);
  for (const group of category.groups) {
    groupKeys.push(group.key);
    groupToCategory[group.key] = category.key;
    for (const item of group.items) {
      itemKeys.push(item.key);
      itemToGroup[item.key] = group.key;
      leafIndex[item.key] = {
        itemKey: item.key,
        itemLabel: item.label,
        groupKey: group.key,
        groupLabel: group.label,
        categoryKey: category.key,
        categoryLabel: category.label
      };
    }
  }
}
var CAPABILITY_ITEM_KEYS = new Set(itemKeys);
var CAPABILITY_GROUP_KEYS = new Set(groupKeys);
var CAPABILITY_CATEGORY_KEYS = new Set(
  categoryKeys
);
var LEAF_INDEX = leafIndex;
var ITEM_TO_GROUP = itemToGroup;
var GROUP_TO_CATEGORY = groupToCategory;
var CAPABILITY_ITEM_COUNT = itemKeys.length;

// src/capability-bridge.ts
var LEGACY_OPERATION_TO_GROUPS = {
  // 1:1
  stamping: ["stamping"],
  sheet_metal_fabrication: ["sheet_metal_fabrication"],
  plastic_injection_molding: ["plastic_injection_molding"],
  heat_treat_and_annealing: ["heat_treating"],
  brazing: ["brazing_soldering"],
  metrology_calibration_cmm_gages: ["metrology_calibration"],
  printed_circuit_boards: ["pcb_electronics_assembly"],
  die_design_and_fabrication: ["tooling_die_build"],
  tooling_components_fixtures_gaging: ["tooling_die_build"],
  // ambiguous -> set of plausible groups
  aluminum_extrusions: [
    "roll_forming_extrusion",
    "metal_materials_mill_products",
    "raw_material_mill_product_supply"
  ],
  wire_and_ribbon_processing: [
    "fastener_hardware_supply",
    "metal_materials_mill_products"
  ],
  raw_material_bar_stock: [
    "raw_material_mill_product_supply",
    "metal_materials_mill_products"
  ],
  machining: [
    "machining_milling",
    "machining_turning",
    "machining_grinding",
    "edm_specialty_machining"
  ],
  castings: [
    "die_casting",
    "castings_sand_investment",
    "permanent_mold_casting"
  ],
  plating_painting_coating_finishing: [
    "plating_anodizing",
    "painting_organic_coating",
    "mechanical_finishing",
    /* pickling and degreasing are pre-treatment steps on a plating line. */
    "cleaning_pickling"
  ],
  ndt_testing_inspection_welding: ["ndt_inspection", "welding"],
  additive_manufacturing: ["additive_polymer", "additive_metal"],
  electrical_component_assembly: [
    "wire_harness_cable_assembly",
    "pcb_electronics_assembly",
    "mechanical_assembly"
  ],
  cutting_and_frame_assembly: [
    "sheet_metal_fabrication",
    "mechanical_assembly"
  ],
  // no process group
  commercial_off_shelf_cots: [],
  industrial_machinery_and_equipment: [],
  original_equipment_manufacturer: [],
  none_of_the_above: []
};
function legacyOperationsToGroups(operations) {
  const groups = /* @__PURE__ */ new Set();
  for (const op of operations) {
    for (const key of LEGACY_OPERATION_TO_GROUPS[op] ?? []) groups.add(key);
  }
  return [...groups];
}
function groupsToLegacyOperations(groups) {
  const wanted = new Set(groups);
  const ops = [];
  for (const [op, mapped] of Object.entries(LEGACY_OPERATION_TO_GROUPS)) {
    if (mapped.some((key) => wanted.has(key)))
      ops.push(op);
  }
  return ops;
}

// src/email-preview.ts
var EMAIL_PREVIEW_GROUPS = [
  "Auth",
  "Onboarding",
  "Billing",
  "RFI",
  "Invoice"
];
var RECEIPT_ATTACHMENT_FILENAME = "tandemone-receipt.pdf";
var EMAIL_PREVIEW_REGISTRY = [
  {
    key: "verification-otp",
    label: "Email verification code",
    group: "Auth",
    trigger: "Signup, before any session is issued."
  },
  {
    key: "password-reset-otp",
    label: "Password reset code",
    group: "Auth",
    trigger: "Forgot-password request."
  },
  {
    key: "email-change-otp",
    label: "Email change code",
    group: "Auth",
    trigger: "Second leg of an email change, sent to the new address after the current one confirms."
  },
  {
    key: "already-registered",
    label: "Already registered",
    group: "Auth",
    trigger: "Signup with an address that already has an account, so the response never leaks who is registered."
  },
  {
    key: "security-alert",
    label: "Security alert",
    group: "Auth",
    trigger: "Any sign-in method change: a provider linked or removed, a password set or changed."
  },
  {
    key: "member-invite",
    label: "Member invitation",
    group: "Auth",
    trigger: "An owner or admin invites someone to their company."
  },
  {
    key: "supplier-approved",
    label: "Supplier approved",
    group: "Onboarding",
    trigger: "A super publishes a supplier profile."
  },
  {
    key: "buyer-approved",
    label: "Buyer approved",
    group: "Onboarding",
    trigger: "A super approves a buyer account."
  },
  {
    key: "public-profile-launch",
    label: "Public profile launch",
    group: "Onboarding",
    trigger: "Not sent yet. Preview only."
  },
  {
    key: "plan-activated",
    label: "Plan activated",
    group: "Billing",
    trigger: "Stripe confirms the first charge after approval.",
    attachments: [
      {
        filename: RECEIPT_ATTACHMENT_FILENAME,
        description: "Stripe's receipt PDF, when the charge produced one."
      }
    ]
  },
  {
    key: "plan-activation-failed",
    label: "Plan activation failed (card declined)",
    group: "Billing",
    trigger: "Approved, then the card on file was refused."
  },
  {
    key: "plan-activation-failed-no-card",
    label: "Plan activation failed (no card)",
    group: "Billing",
    trigger: "Approved with a paid plan chosen but no payment method on file."
  },
  {
    key: "plan-invoice",
    label: "Plan invoice",
    group: "Billing",
    trigger: "A company billed by invoice rather than card is issued one."
  },
  {
    key: "plan-payment-received",
    label: "Plan payment received",
    group: "Billing",
    trigger: "A recurring subscription charge clears.",
    attachments: [
      {
        filename: RECEIPT_ATTACHMENT_FILENAME,
        description: "Stripe's receipt PDF, when the charge produced one."
      }
    ]
  },
  {
    key: "rfi-received",
    label: "RFI received",
    group: "RFI",
    trigger: "A buyer broadcasts an RFI to a supplier whose plan shows detail."
  },
  {
    key: "rfi-received-locked",
    label: "RFI received (plan-locked)",
    group: "RFI",
    trigger: "Same broadcast to a supplier whose plan withholds the buyer identity."
  },
  {
    key: "invoice",
    label: "Invoice issued",
    group: "Invoice",
    trigger: "A supplier issues an invoice to another supplier.",
    attachments: [
      {
        filename: "INV-1.pdf",
        description: "The rendered invoice, named for its number. Always attached."
      }
    ]
  }
];
function emailPreviewGroupSlug(group) {
  return group.toLowerCase();
}
function emailPreviewSlug(label) {
  return label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
}

// src/events.ts
var EVENTS = {
  // identity events
  USER_SIGNED_UP: "user_signed_up",
  USER_LOGGED_IN: "user_logged_in",
  USER_LOGGED_OUT: "user_logged_out",
  USER_VERIFICATION_EMAIL_SENT: "user_verification_email_sent",
  USER_EMAIL_VERIFIED: "user_email_verified",
  USER_DEACTIVATED: "user_deactivated",
  USER_REACTIVATED: "user_reactivated",
  USER_VERIFICATION_EMAIL_RESENT: "user_verification_email_resent",
  USER_EMAIL_CHANGE_REQUESTED: "user_email_change_requested",
  USER_EMAIL_CHANGED: "user_email_changed",
  USER_PASSWORD_CHANGED: "user_password_changed",
  USER_SIGNIN_METHOD_CONNECTED: "user_signin_method_connected",
  USER_SIGNIN_METHOD_DISCONNECTED: "user_signin_method_disconnected",
  // onboarding events
  COMPANY_CREATED: "company_created",
  // company switcher events
  ACTIVE_COMPANY_SWITCHED: "active_company_switched",
  ADDITIONAL_COMPANY_CREATED: "additional_company_created",
  ADD_COMPANY_SHEET_OPENED: "add_company_sheet_opened",
  ADD_COMPANY_SHEET_SUBMITTED: "add_company_sheet_submitted",
  ADD_COMPANY_SHEET_FAILED: "add_company_sheet_failed",
  // company member events
  COMPANY_MEMBER_INVITED: "company_member_invited",
  COMPANY_MEMBER_INVITE_RESENT: "company_member_invite_resent",
  COMPANY_MEMBER_INVITE_CANCELLED: "company_member_invite_cancelled",
  COMPANY_MEMBER_JOINED: "company_member_joined",
  COMPANY_MEMBER_ROLE_CHANGED: "company_member_role_changed",
  COMPANY_MEMBER_STATUS_CHANGED: "company_member_status_changed",
  COMPANY_MEMBER_REMOVED: "company_member_removed",
  // supplier onboarding events
  SUPPLIER_ONBOARDING_STARTED: "supplier_onboarding_started",
  SUPPLIER_ONBOARDING_STEP_COMPLETED: "supplier_onboarding_step_completed",
  SUPPLIER_ONBOARDING_STEP_UPDATED: "supplier_onboarding_step_updated",
  SUPPLIER_ONBOARDING_SECTION_COMPLETED: "supplier_onboarding_section_completed",
  SUPPLIER_ONBOARDING_COMPLETED: "supplier_onboarding_completed",
  SUPPLIER_DOCUMENT_UPLOADED: "supplier_document_uploaded",
  SUPPLIER_CERTIFICATE_UPLOADED: "supplier_certificate_uploaded",
  SUPPLIER_CERTIFICATE_VERIFIED: "supplier_certificate_verified",
  SUPPLIER_PROFILE_PUBLISHED: "supplier_profile_published",
  SUPPLIER_DOCUMENT_VIEWED: "supplier_document_viewed",
  SUPPLIER_CERTIFICATE_VIEWED: "supplier_certificate_viewed",
  // discovery events
  SUPPLIER_SEARCH_PERFORMED: "supplier_search_performed",
  SUPPLIER_PROFILE_VIEWED: "supplier_profile_viewed",
  // verification events
  SUPPLIER_VERIFIED: "supplier_verified",
  BUYER_VERIFIED: "buyer_verified",
  SUPPLIER_HIDDEN: "supplier_hidden",
  SUPPLIER_UNHIDDEN: "supplier_unhidden",
  // buyer onboarding events
  BUYER_ONBOARDING_STARTED: "buyer_onboarding_started",
  BUYER_ONBOARDING_STEP_COMPLETED: "buyer_onboarding_step_completed",
  BUYER_ONBOARDING_STEP_UPDATED: "buyer_onboarding_step_updated",
  BUYER_ONBOARDING_COMPLETED: "buyer_onboarding_completed",
  // messaging events
  CONVERSATION_CREATED: "conversation_created",
  MESSAGE_SENT: "message_sent",
  MESSAGE_UNSENT: "message_unsent",
  // invoice events
  INVOICE_CREATED: "invoice_created",
  BILLING_PAYMENT_FAILED: "billing_payment_failed",
  BILLING_ACTIVATION_FAILED: "billing_activation_failed",
  BILLING_ACTIVATED: "billing_activated",
  BILLING_INVOICE_ISSUED: "billing_invoice_issued",
  BILLING_PAYMENT_RECEIVED: "billing_payment_received",
  SUPPLIER_RFI_DETAIL_UNLOCKED: "supplier_rfi_detail_unlocked",
  INVOICE_ISSUED: "invoice_issued",
  INVOICE_PAID: "invoice_paid",
  INVOICE_CANCELLED: "invoice_cancelled",
  // rfi events
  RFI_CREATED: "rfi_created",
  RFI_STARTED: "rfi_started",
  RFI_COMPLETED: "rfi_completed",
  RFI_SENT: "rfi_sent",
  RFI_DUPLICATE_SENT: "rfi_duplicate_sent",
  RFI_RECEIVED: "rfi_received",
  RFI_RESPONDED: "rfi_responded",
  RFI_CANCELLED: "rfi_cancelled",
  // push subscription events
  PUSH_SUBSCRIPTION_ACTIVATED: "push_subscription_activated",
  // engagement events
  USER_RETURNED: "user_returned",
  /* the only sanctioned count-only event. pageviews are the canonical
   * rowless-behavior signal and tool activity has no postgres alternative,
   * so this is a deliberate exception to "never emit an event whose only
   * purpose is to be summed later". the imported history calls it `$pageview`,
   * which the importer renames to this. */
  PAGE_VIEWED: "page_viewed"
};
var SUPPLIER_STEPS = {
  BUSINESS_CONTACTS: "business_contacts",
  OPERATIONS: "operations",
  CAPITAL_EQUIPMENT: "capital_equipment",
  CERTIFICATES: "certificates",
  GENERAL_INFO: "general_info",
  INDUSTRIES: "industries",
  MANUFACTURING_LOCATIONS: "manufacturing_locations",
  MEASUREMENT_CAPABILITIES: "measurement_capabilities",
  PLAN: "plan",
  POLICIES: "policies",
  QUALITY_CONTINUAL_IMPROVEMENT: "quality_continual_improvement",
  QUALITY_INSPECTION_MEASUREMENT: "quality_inspection_measurement",
  QUALITY_MANAGEMENT_REQUIREMENTS: "quality_management_requirements",
  QUALITY_NONCONFORMANCE_MAINTENANCE: "quality_nonconformance_maintenance",
  QUALITY_PURCHASING_SUPPLIER_SELECTION: "quality_purchasing_supplier_selection",
  QUALITY_RISK_ASSESSMENT: "quality_risk_assessment",
  SALES_HISTORY: "sales_history",
  WORKFORCE: "workforce"
};
var SUPPLIER_SECTIONS = {
  COMPANY: "company",
  DOCUMENTS: "documents",
  DUE_DILIGENCE: "due_diligence",
  PLAN: "plan",
  QUALITY_ASSESSMENT: "quality_assessment"
};
var SUPPLIER_STEP_SECTION = {
  [SUPPLIER_STEPS.GENERAL_INFO]: SUPPLIER_SECTIONS.COMPANY,
  [SUPPLIER_STEPS.BUSINESS_CONTACTS]: SUPPLIER_SECTIONS.COMPANY,
  [SUPPLIER_STEPS.POLICIES]: SUPPLIER_SECTIONS.DUE_DILIGENCE,
  [SUPPLIER_STEPS.WORKFORCE]: SUPPLIER_SECTIONS.DUE_DILIGENCE,
  [SUPPLIER_STEPS.OPERATIONS]: SUPPLIER_SECTIONS.DUE_DILIGENCE,
  [SUPPLIER_STEPS.INDUSTRIES]: SUPPLIER_SECTIONS.DUE_DILIGENCE,
  [SUPPLIER_STEPS.SALES_HISTORY]: SUPPLIER_SECTIONS.DUE_DILIGENCE,
  [SUPPLIER_STEPS.MANUFACTURING_LOCATIONS]: SUPPLIER_SECTIONS.DUE_DILIGENCE,
  [SUPPLIER_STEPS.CAPITAL_EQUIPMENT]: SUPPLIER_SECTIONS.DUE_DILIGENCE,
  [SUPPLIER_STEPS.MEASUREMENT_CAPABILITIES]: SUPPLIER_SECTIONS.QUALITY_ASSESSMENT,
  [SUPPLIER_STEPS.QUALITY_MANAGEMENT_REQUIREMENTS]: SUPPLIER_SECTIONS.QUALITY_ASSESSMENT,
  [SUPPLIER_STEPS.QUALITY_RISK_ASSESSMENT]: SUPPLIER_SECTIONS.QUALITY_ASSESSMENT,
  [SUPPLIER_STEPS.QUALITY_NONCONFORMANCE_MAINTENANCE]: SUPPLIER_SECTIONS.QUALITY_ASSESSMENT,
  [SUPPLIER_STEPS.QUALITY_INSPECTION_MEASUREMENT]: SUPPLIER_SECTIONS.QUALITY_ASSESSMENT,
  [SUPPLIER_STEPS.QUALITY_PURCHASING_SUPPLIER_SELECTION]: SUPPLIER_SECTIONS.QUALITY_ASSESSMENT,
  [SUPPLIER_STEPS.QUALITY_CONTINUAL_IMPROVEMENT]: SUPPLIER_SECTIONS.QUALITY_ASSESSMENT,
  [SUPPLIER_STEPS.CERTIFICATES]: SUPPLIER_SECTIONS.DOCUMENTS,
  [SUPPLIER_STEPS.PLAN]: SUPPLIER_SECTIONS.PLAN
};
function supplierStepProperties(stepId) {
  return { step_id: stepId, section_id: SUPPLIER_STEP_SECTION[stepId] };
}
var SUPPLIER_STEP_LABELS = {
  [SUPPLIER_STEPS.GENERAL_INFO]: "General Info",
  [SUPPLIER_STEPS.POLICIES]: "Policies",
  [SUPPLIER_STEPS.WORKFORCE]: "Workforce",
  [SUPPLIER_STEPS.BUSINESS_CONTACTS]: "Business Contacts",
  [SUPPLIER_STEPS.OPERATIONS]: "Operations & Capabilities",
  [SUPPLIER_STEPS.INDUSTRIES]: "Industries",
  [SUPPLIER_STEPS.SALES_HISTORY]: "Sales History",
  [SUPPLIER_STEPS.MANUFACTURING_LOCATIONS]: "Manufacturing Locations",
  [SUPPLIER_STEPS.CAPITAL_EQUIPMENT]: "Capital Equipment",
  [SUPPLIER_STEPS.MEASUREMENT_CAPABILITIES]: "Measurement Capabilities",
  [SUPPLIER_STEPS.QUALITY_MANAGEMENT_REQUIREMENTS]: "Quality: Management Requirements",
  [SUPPLIER_STEPS.QUALITY_RISK_ASSESSMENT]: "Quality: Risk Assessment",
  [SUPPLIER_STEPS.QUALITY_NONCONFORMANCE_MAINTENANCE]: "Quality: Nonconformance & Maintenance",
  [SUPPLIER_STEPS.QUALITY_INSPECTION_MEASUREMENT]: "Quality: Inspection & Measurement",
  [SUPPLIER_STEPS.QUALITY_PURCHASING_SUPPLIER_SELECTION]: "Quality: Purchasing & Supplier Selection",
  [SUPPLIER_STEPS.QUALITY_CONTINUAL_IMPROVEMENT]: "Quality: Continual Improvement",
  [SUPPLIER_STEPS.CERTIFICATES]: "Certificates",
  [SUPPLIER_STEPS.PLAN]: "Plan"
};
var SUPPLIER_SECTION_LABELS = {
  [SUPPLIER_SECTIONS.COMPANY]: "Company",
  [SUPPLIER_SECTIONS.DUE_DILIGENCE]: "Due Diligence",
  [SUPPLIER_SECTIONS.QUALITY_ASSESSMENT]: "Quality Assessment",
  [SUPPLIER_SECTIONS.DOCUMENTS]: "Documents",
  [SUPPLIER_SECTIONS.PLAN]: "Plan"
};
var BUYER_STEPS = {
  GENERAL_INFO: "general_info",
  BUSINESS_CONTACTS: "business_contacts"
};
var BUYER_STEP_LABELS = {
  [BUYER_STEPS.GENERAL_INFO]: "General Info",
  [BUYER_STEPS.BUSINESS_CONTACTS]: "Business Contacts"
};
var BROWSER_EVENTS = [
  EVENTS.PAGE_VIEWED,
  EVENTS.USER_RETURNED,
  EVENTS.SUPPLIER_PROFILE_VIEWED,
  EVENTS.SUPPLIER_DOCUMENT_VIEWED,
  EVENTS.SUPPLIER_CERTIFICATE_VIEWED,
  EVENTS.SUPPLIER_SEARCH_PERFORMED,
  EVENTS.RFI_STARTED,
  EVENTS.RFI_COMPLETED,
  EVENTS.ADD_COMPANY_SHEET_OPENED,
  EVENTS.ADD_COMPANY_SHEET_SUBMITTED,
  EVENTS.ADD_COMPANY_SHEET_FAILED
];
var GEO_ENRICHED_EVENTS = [
  EVENTS.SUPPLIER_PROFILE_VIEWED,
  EVENTS.SUPPLIER_DOCUMENT_VIEWED,
  EVENTS.SUPPLIER_CERTIFICATE_VIEWED
];

// src/metals.ts
var METALS_CATALOG = [
  {
    symbol: "US-HRC",
    label: "Hot-Rolled Coil Steel",
    unit: "USD per short ton",
    market: "cme"
  },
  {
    symbol: "ALU",
    label: "Aluminum",
    unit: "USD per short ton",
    market: "lme"
  },
  { symbol: "XCU", label: "Copper", unit: "USD per short ton", market: "lme" },
  { symbol: "NI", label: "Nickel", unit: "USD per short ton", market: "lme" },
  { symbol: "ZNC", label: "Zinc", unit: "USD per short ton", market: "lme" },
  {
    symbol: "MO",
    label: "Molybdenum",
    unit: "USD per kilogram",
    market: "global"
  }
];

// src/notification-registry.ts
var NOTIFICATION_CATEGORIES = {
  PLATFORM_ACTIVITY: "platform-activity",
  ONBOARDING: "onboarding",
  MESSAGING: "messaging",
  SECURITY: "security"
};
var ALL_CHANNELS_ON = {
  inApp: true,
  toast: true,
  push: true,
  email: true
};
var NOTIFICATION_REGISTRY = {
  user_signed_up: {
    type: "user_signed_up",
    label: "New user signed up",
    description: "Fires when anyone creates an account on the platform.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: false, email: false }
  },
  company_created: {
    type: "company_created",
    label: "New company created",
    description: "Fires when someone creates a company during signup.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: false, email: false }
  },
  supplier_onboarding_started: {
    type: "supplier_onboarding_started",
    label: "Supplier started onboarding",
    description: "A company picked the supplier path and began their onboarding flow.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: false, email: false }
  },
  buyer_onboarding_started: {
    type: "buyer_onboarding_started",
    label: "Buyer started onboarding",
    description: "A company picked the buyer path and began their onboarding flow.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: false, email: false }
  },
  supplier_onboarding_step_completed: {
    type: "supplier_onboarding_step_completed",
    label: "Supplier completed an onboarding step",
    description: "A supplier finished a section of their onboarding.",
    category: NOTIFICATION_CATEGORIES.ONBOARDING,
    mutable: true,
    defaultChannels: { inApp: true, toast: false, push: false, email: false }
  },
  supplier_onboarding_step_updated: {
    type: "supplier_onboarding_step_updated",
    label: "Supplier updated an onboarding step",
    description: "A supplier changed a step they had already completed.",
    category: NOTIFICATION_CATEGORIES.ONBOARDING,
    mutable: true,
    defaultChannels: { inApp: true, toast: false, push: false, email: false }
  },
  supplier_onboarding_section_completed: {
    type: "supplier_onboarding_section_completed",
    label: "Supplier completed an onboarding section",
    description: "A supplier finished an entire onboarding section (e.g. Due Diligence).",
    category: NOTIFICATION_CATEGORIES.ONBOARDING,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: false, email: false }
  },
  supplier_onboarding_completed: {
    type: "supplier_onboarding_completed",
    label: "Supplier finished onboarding",
    description: "A supplier has completed all onboarding steps.",
    category: NOTIFICATION_CATEGORIES.ONBOARDING,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: true, email: false }
  },
  buyer_onboarding_step_completed: {
    type: "buyer_onboarding_step_completed",
    label: "Buyer completed an onboarding step",
    description: "A buyer finished a step of their company onboarding.",
    category: NOTIFICATION_CATEGORIES.ONBOARDING,
    mutable: true,
    defaultChannels: { inApp: true, toast: false, push: false, email: false }
  },
  buyer_onboarding_step_updated: {
    type: "buyer_onboarding_step_updated",
    label: "Buyer updated an onboarding step",
    description: "A buyer changed a step they had already completed.",
    category: NOTIFICATION_CATEGORIES.ONBOARDING,
    mutable: true,
    defaultChannels: { inApp: true, toast: false, push: false, email: false }
  },
  buyer_onboarding_completed: {
    type: "buyer_onboarding_completed",
    label: "Buyer finished onboarding",
    description: "A buyer has completed company information and contacts.",
    category: NOTIFICATION_CATEGORIES.ONBOARDING,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: true, email: false }
  },
  supplier_profile_published: {
    type: "supplier_profile_published",
    label: "Supplier profile published",
    description: "A supplier published their profile to the directory.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: false, email: false }
  },
  supplier_certificate_uploaded: {
    type: "supplier_certificate_uploaded",
    label: "Supplier uploaded a certificate",
    description: "A supplier added a new certificate to their profile.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    defaultChannels: { inApp: true, toast: false, push: false, email: false }
  },
  supplier_approved: {
    type: "supplier_approved",
    label: "Your profile was approved",
    description: "Staff approved your supplier profile and it is now listed.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: false,
    defaultChannels: { inApp: true, toast: true, push: true, email: true }
  },
  buyer_approved: {
    type: "buyer_approved",
    label: "Your account was approved",
    description: "Staff approved your buyer account and sourcing is unlocked.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: false,
    defaultChannels: { inApp: true, toast: true, push: true, email: true }
  },
  invoice_issued: {
    type: "invoice_issued",
    label: "Invoice received",
    description: "Another company sent you an invoice.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    /**
     * email goes out separately from the invoice service (PDF attached), so
     * the registry email channel stays off to avoid a duplicate send.
     */
    defaultChannels: { inApp: true, toast: true, push: true, email: false }
  },
  billing_payment_failed: {
    type: "billing_payment_failed",
    label: "Payment failed",
    description: "A payment for your plan could not be collected.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    /* losing the plan is not something to opt out of. */
    mutable: false,
    /* email is off because stripe sends its own dunning mail carrying the
     * payment link, so ours would say less alongside it. email-renderers.ts
     * returns null to match. */
    defaultChannels: { inApp: true, toast: true, push: true, email: false }
  },
  billing_activation_failed: {
    type: "billing_activation_failed",
    label: "Plan could not start",
    description: "We approved your profile but could not start the plan you chose.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    /* they are on the free tier until they act, so this is not optional. */
    mutable: false,
    defaultChannels: { inApp: true, toast: true, push: true, email: true }
  },
  billing_activated: {
    type: "billing_activated",
    label: "Plan started",
    description: "A payment went through and your plan is now active.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: false,
    defaultChannels: { inApp: true, toast: true, push: true, email: true }
  },
  billing_invoice_issued: {
    type: "billing_invoice_issued",
    label: "Invoice ready to pay",
    description: "We issued an invoice for your plan.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: false,
    defaultChannels: { inApp: true, toast: true, push: true, email: true }
  },
  billing_payment_received: {
    type: "billing_payment_received",
    label: "Payment received",
    description: "We received a payment and attached the receipt.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: false,
    defaultChannels: { inApp: true, toast: false, push: false, email: true }
  },
  rfi_received: {
    type: "rfi_received",
    label: "RFI received",
    description: "A buyer sent your company a request for information.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    /**
     * first type to opt into the email channel, the notification service
     * renders + sends it via Resend (no bespoke per-domain send).
     */
    defaultChannels: { inApp: true, toast: true, push: true, email: true }
  },
  company_member_joined: {
    type: "company_member_joined",
    label: "New member joined",
    description: "Someone accepted an invite and joined your company.",
    category: NOTIFICATION_CATEGORIES.PLATFORM_ACTIVITY,
    mutable: true,
    defaultChannels: { inApp: true, toast: true, push: false, email: false }
  },
  message_received: {
    type: "message_received",
    label: "New message",
    description: "Fires when another participant posts in one of your conversations.",
    category: NOTIFICATION_CATEGORIES.MESSAGING,
    mutable: true,
    /**
     * toast=false here on purpose, the messaging socket already shows a
     * sonner toast when the recipient is off-thread, scoped to live route.
     * the registry's toast channel would duplicate that.
     */
    defaultChannels: { inApp: true, toast: false, push: true, email: false }
  }
};
function getNotificationRegistryEntry(type) {
  return NOTIFICATION_REGISTRY[type];
}

// src/supplier-collections.ts
var NONE_OF_THE_ABOVE = "none_of_the_above";
var SUPPLIER_CERTIFICATE_LABELS = {
  as9100: "AS9100",
  ce_marking: "CE Marking",
  iatf_16949: "IATF 16949",
  iec_61730: "IEC 61730",
  iso_13485: "ISO 13485",
  iso_14001: "ISO 14001",
  iso_3834: "ISO 3834",
  iso_45001: "ISO 45001",
  iso_9001: "ISO 9001",
  itar_registered: "ITAR Registered",
  lean_manufacturing_certificate: "Lean Manufacturing certificate",
  nadcap: "NADCAP",
  reach_compliant: "REACH Compliant",
  rohs_compliant: "RoHS Compliant",
  six_sigma_certificate: "Six Sigma certificate",
  ts_16949: "TS 16949",
  ul_certified: "UL Certified",
  ul_listed: "UL Listed"
};
var QA_SKIP_CERTS = [
  "iso_9001",
  "iatf_16949",
  "as9100",
  "iso_13485"
];
var QA_SECTION_ORDER = [
  "management_requirements",
  "risk_assessment",
  "nonconformance_maintenance",
  "inspection_measurement",
  "purchasing_supplier_selection",
  "continual_improvement"
];
var QA_SECTION_QUESTIONS = {
  management_requirements: [
    "quality_policy",
    "quality_manual",
    "management_review",
    "quality_system_verification",
    "corrective_preventative_action"
  ],
  risk_assessment: [
    "contract_review_process",
    "risk_assessment",
    "document_data_control",
    "quality_records",
    "control_plans_work_instructions"
  ],
  nonconformance_maintenance: [
    "nonconforming_products",
    "preventative_maintenance",
    "measurement_equipment_calibration",
    "final_inspection",
    "training"
  ],
  inspection_measurement: [
    "in_person_inspections",
    "verification_job_set_up",
    "material_certifications",
    "quality_requirements"
  ],
  purchasing_supplier_selection: [
    "purchasing",
    "product_identification",
    "lot_integrity_traceability",
    "process_validation",
    "process_capability_spc"
  ],
  continual_improvement: [
    "continual_improvement",
    "ppm_otd_metrics",
    "customer_audits",
    "customer_scorecards",
    "internal_goals_objectives"
  ]
};
var QA_TOTAL_QUESTIONS = 29;

// src/supplier-directory.ts
var CAPABILITY_GROUP_LABELS = Object.fromEntries(
  CAPABILITY_TAXONOMY.flatMap(
    (category) => category.groups.map((group) => [group.key, group.label])
  )
);
function capabilityGroupLabels(profile) {
  const groupKeys2 = profile.capabilities.length > 0 ? profile.capabilities.map((cap) => ITEM_TO_GROUP[cap.capabilityItemKey]) : legacyOperationsToGroups(profile.operations.map((op) => op.operation));
  return [...new Set(groupKeys2)].flatMap(
    (key) => key && CAPABILITY_GROUP_LABELS[key] ? [CAPABILITY_GROUP_LABELS[key]] : []
  );
}
function supplierNetworkTitle(profile) {
  const detail = [
    capabilityGroupLabels(profile).slice(0, 2).join(" and "),
    profile.supplier.region ?? profile.supplier.country
  ].filter(Boolean).join(", ");
  return detail ? `${profile.company.name} \u2014 ${detail}` : profile.company.name;
}
export {
  ACTIVATION_RETRY_LABELS,
  ACTIVE_COMPANY_COOKIE_NAME,
  ALL_CHANNELS_ON,
  ANALYTICS_BATCH_MAX_EVENTS,
  ANALYTICS_CLOCK_SKEW_MS,
  ANALYTICS_PROPERTIES_MAX_CHARS,
  AUTH_PATH_PREFIX,
  BILLING_ACTIVATION_FAILURES,
  BROWSER_EVENTS,
  BUYER_STEPS,
  BUYER_STEP_LABELS,
  CAPABILITY_CATEGORY_KEYS,
  CAPABILITY_GROUP_KEYS,
  CAPABILITY_ITEM_COUNT,
  CAPABILITY_ITEM_KEYS,
  CAPABILITY_TAXONOMY,
  CAPABILITY_TAXONOMY_VERSION,
  COUNTRY_NAME_BY_CODE,
  EMAIL_PREVIEW_GROUPS,
  EMAIL_PREVIEW_REGISTRY,
  EVENTS,
  GEO_ENRICHED_EVENTS,
  GROUP_TO_CATEGORY,
  INVOICE_BILLED_COUNTRIES,
  ITEM_TO_GROUP,
  LEAF_INDEX,
  LEGACY_OPERATION_TO_GROUPS,
  METALS_CATALOG,
  NONE_OF_THE_ABOVE,
  NOTIFICATION_CATEGORIES,
  NOTIFICATION_REGISTRY,
  NO_ENTITLEMENTS,
  NO_PLAN_FEATURES,
  PLAN_CATALOG,
  PLAN_FEATURE_KEYS,
  PLAN_IDS,
  PURCHASABLE_PLAN_IDS,
  QA_SECTION_ORDER,
  QA_SECTION_QUESTIONS,
  QA_SKIP_CERTS,
  QA_TOTAL_QUESTIONS,
  RECEIPT_ATTACHMENT_FILENAME,
  SUPER_SCOPE,
  SUPPLIER_CERTIFICATE_LABELS,
  SUPPLIER_SECTIONS,
  SUPPLIER_SECTION_LABELS,
  SUPPLIER_STEPS,
  SUPPLIER_STEP_LABELS,
  SUPPLIER_STEP_SECTION,
  UNITED_STATES_COUNTRY_CODE,
  additionalUserFields,
  capabilityGroupLabels,
  countryNameFromCode,
  effectiveSeatCap,
  emailPreviewGroupSlug,
  emailPreviewSlug,
  freePlanFor,
  getNotificationRegistryEntry,
  groupsToLegacyOperations,
  isCompedSubscription,
  isPaidPlan,
  isPlanOffered,
  legacyOperationsToGroups,
  resolveCollectionMethod,
  resolveCountryCode,
  supplierNetworkTitle,
  supplierStepProperties,
  unionFeatures
};
